import { render, staticRenderFns } from "./start-btn.vue?vue&type=template&id=a44c7db8&scoped=true"
import script from "./start-btn.vue?vue&type=script&lang=js"
export * from "./start-btn.vue?vue&type=script&lang=js"
import style0 from "./start-btn.vue?vue&type=style&index=0&id=a44c7db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44c7db8",
  null
  
)

export default component.exports